<template>
  <div class="weather-component" @click.stop.prevent :style="getTextStyle">
    <div ref="textInner" class="weather-labels-wrap">
      <div class="weather-labels" v-for="(content, index) in getWeatherContent" :key="index" :style="getTextColor">
        <span v-if="content.type !== 'img'"> {{ content.label }}</span>
        <img :style="getImgStyle" v-else-if="content.iconStyle === 1" class="weather-icon" :src="content.src" alt="" />
        <span class="icon" :style="getIconStyle" v-else-if="content.iconStyle === 2" :class="content.iconName"></span>
      </div>
    </div>
  </div>
</template>

<script>
import instance from "@/interceptor"
import eventMixin from "utils/event/eventMixin.js"
import dataRenderMixin from "materials/dataRenderMixin"

export default {
  mixins: [eventMixin, dataRenderMixin],
  name: "cxweather",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      newWeather: undefined
    }
  },
  created() {
    if (this.isBigScreenPreview() && this.options.showSelectCity) {
      setTimeout(()=>{
        this.getWeatherData(true)
      }, 500)
    }else{
      this.getWeatherData()
    }
  },
  mounted() {
    if (this.$refs.textInner) {
      this.$refs.textInner.style.transform = "rotate(" + this.options.rotate + "deg)"
    }
  },
  watch: {
    "options.selectName"(n, o) {
      if(n !== o){
        this.getWeatherData(true)
      }
    },
    "options.showSelectCity"(n, o) {
      this.getWeatherData(true)
    },
  },
  computed: {
    getTextColor() {
      let colorStyle = {}
      if (this.options.colorType === "线性渐变") {
        colorStyle = {
          color: "transparent",
          "background-image":
              `linear-gradient(90deg,${this.$parseColor(this.options.startColor)},${this.$parseColor(this.options.endColor)})`,
          "-webkit-background-clip": "text",
          display: this.options.wordWrap ? "block" : "inline-block",
          padding: this.options.wordWrap ? `${this.options.spacing}px 0 ` : `0 ${this.options.spacing}px`
        }
      } else {
        colorStyle = {
          color: this.$parseColor(this.options.color),
          display: this.options.wordWrap ? "block" : "inline-block",
          padding: this.options.wordWrap ? `${this.options.spacing}px 0 ` : `0 ${this.options.spacing}px`
        }
      }
      return colorStyle
    },
    weather() {
      if (this.isBigScreenPreview() && !this.options.showSelectCity) {
        this.updateDate = true
        return this.$store.state.states.weatherAndDate
      } else {
        return this.newWeather
      }
    },
    getWeatherContent() {
      let content = []
      if (!this.weather) {
        return []
      }

      // 图标/图片相关设置
      content[this.options.showIconOrder - 1] = {
        type: "img",
        src: this.weather.dayImg,
        show: this.options.showIcon,
        iconName: `icon-portal-${this.weather.dayClass}`,
        iconStyle: this.options.iconStyle
      }
      content[this.options.showCityOrder - 1] = {
        type: "text",
        label: this.weather.city,
        show: this.options.showCity
      }
      content[this.options.showWeatherTextOrder - 1] = {
        type: "text",
        label: this.weather.weather,
        show: this.options.showWeatherText
      }
      content[this.options.showTempOrder - 1] = {
        type: "text",
        label: this.weather.temp,
        show: this.options.showDayTemp
      }
      // 最低温到最高温
      if(this.options.showTempRange){
        content.push({
          type: "text",
          label: `${this.weather.lowTemp}~${this.weather.highTemp}`,
          show: this.options.showTempRange
        })
      }
      for (let i = 0; i < content.length; i++) {
        if (!content[i].show) {
          content.splice(i, 1)
          i--
        }
      }
      return content
    },
    getTextStyle() {
      if (this.$refs.textInner) {
        this.$refs.textInner.style.transform = "rotate(" + this.options.rotate + "deg)"
        this.$refs.textInner.style.background = this.bgColor
      }
      return {
        "font-style": this.options.fontStyle,
        "font-Family": this.options.fontFamily,
        "font-size": this.options.fontSize + "px",
        "font-weight": this.options.fontWeight,
        // top: this.options.top,
        left: this.options.left
      }
    },
    getImgStyle() {
      return {
        width: this.options.iconSize + "px"
      }
    },
    getIconStyle() {
      return {
        fontSize: this.options.iconSize + "px"
      }
    },
  },
  methods: {
    // 获取天气接口
    getWeatherData(isFresh) {
      let weatherUrl = "engine2/weather/today-v3"
      if (typeof this.weather === "undefined" || isFresh) {
        if(this.options.showSelectCity){
          let name = this.options.selectName
          const nameList = name.split("/")
          let districtId = nameList.length > 1 ? nameList[1].split(".")[1] : ""
          if(!districtId){
            districtId = nameList.length > 1 ? nameList[2].split(".")[1] : ""
          }
          weatherUrl = weatherUrl + "?districtId=" + districtId
        }
        instance.get(weatherUrl).then(res => {
          if (res.data.code === 1) {
            this.updateDate = true
            this.newWeather = res.data.data
            // todo  测试数据 因10上这个接口返回的数据有问题 上线需切换
            // setTimeout(() => {
            //   this.newWeather = {
            //     "date": "2025年01月13日",
            //     "dateTime": "2025-01-13 11:16:28",
            //     "temp": "6 ℃",
            //     "city": "成都",
            //     "nightImg": "/engine2/upload/engine/template/weather/style1/n1.png",
            //     "feelsLike": "6 ℃",
            //     "dayClass": "d1",
            //     "dayImg": "/engine2/upload/engine/template/weather/style1/d1.png",
            //     "hasWeatherImg": true,
            //     "rh": "83%",
            //     "nightClass": "n1",
            //     "lowTemp": "4",
            //     "weather": "多云",
            //     "highTemp": "10 ℃",
            //     "day": "星期一",
            //     "wind": "1级南风"
            //   }
            // }, 1000)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.weather-component,
.weather-component > div {
  transition: transform 0.5s;
}
.weather-component {
  font-size: 20px;
  color: #fff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.weather-icon {
  width: 54px;
}
.weather-labels-wrap .weather-labels:first-child {
  padding-left: 0 !important;
  padding-top: 0 !important;
}
.weather-labels {
  line-height: 1;
  vertical-align: middle;
}

.weather-labels .icon {
  display: inline-block;
}
</style>
